import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';

const ADMIN_DOMAIN = 'natureanalytics.earth';

/**
 * Returns true if the current user has an @natureanalytics.earth email.
 * Checks both the MSAL user object and the backend auth response.
 */
const useIsAdmin = () => {
  const { user, isAuthenticated } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) {
      setIsAdmin(false);
      setChecked(true);
      return;
    }
    const email = user.email || user.username || '';
    setIsAdmin(email.endsWith(`@${ADMIN_DOMAIN}`));
    setChecked(true);
  }, [isAuthenticated, user]);

  return { isAdmin, checked };
};

export default useIsAdmin;
